const getDefaultState = () => {
  return {
    notices: {
      adsNotice: true,
    },
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_NOTICES(state, notices) {
    state.notices = notices;
  },
  SET_NOTICE_STATE(state, noticeData) {
    state.notices[noticeData.notice] = noticeData.noticeState;
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setNotices({ commit }, notices) {
    commit("SET_NOTICES", notices);
  },

  setNoticeState({ commit }, noticeData) {
    commit("SET_NOTICE_STATE", noticeData);
  },
};

const updates = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default updates;
